// This file is copied from https://github.com/googleapis/api-common-protos/blob/main/google/type/timeofday.proto
// and modified to use the carmen package.

// Represents a time of day. The date and time zone are either not significant
// or are specified elsewhere. An API may choose to allow leap seconds. Related
// types are [Date][Date] and `google.protobuf.Timestamp`.

// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/timeofday.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/timeofday.proto.
 */
export const file_proto_model_core_timeofday = /*@__PURE__*/
  fileDesc("CiBwcm90by9tb2RlbC9jb3JlL3RpbWVvZmRheS5wcm90bxIGY2FybWVuIksKCVRpbWVPZkRheRINCgVob3VycxgBIAEoBRIPCgdtaW51dGVzGAIgASgFEg8KB3NlY29uZHMYAyABKAUSDQoFbmFub3MYBCABKAVCQgoGY2FybWVuQg5UaW1lT2ZEYXlQcm90b1ABWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z");

/**
 * Describes the message carmen.TimeOfDay.
 * Use `create(TimeOfDaySchema)` to create a new message.
 */
export const TimeOfDaySchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_timeofday, 0);

